export default {
  getConsorcios(state) {
    return state.consorcios
  }
}
